export const SINGLE_LINE_INPUT_MAX_LENGTH = 250;
export const TEXT_AREA_MAX_LENGTH = 500;
